<template>
  <footer>
    <div class="wrap row">
      <div class="logo">
        <a href="#">
          <img src="/static/images/logo/logo-white.svg" alt="">
        </a>
      </div>

      <div class="main-footer">
        <div class="main-footer-title">
          Spar Nord Bank A/S
        </div>
        <div class="main-sub-footer">

          <div class="main-sub-footer__group">
            <div>
              <span>
                Skelagervej 15 <br>
                Postboks 162 <br>
                9100 Aalborg
              </span>
            </div>
            <div>
              <span class="has-icon">
                <icon class="icon" name="phone"></icon>
                96 16 13 31
              </span>
              <span class="has-icon link">
                <icon class="icon" name="envelope"></icon>
                <a href="mailto:sparnord@sparnord.dk">sparnord@sparnord.dk</a>
              </span>
            </div>
          </div>

          <div class="main-sub-footer__group">
            <div>
              <span>Cvr:</span>
              <span>13737584</span>
            </div>
            <div>
              <span>BIC/SWIFT:</span>
              <span>SPNODK22</span>
            </div>
            <div>
              <span>GIIN nr:</span>
              <span>NBDPS6.99999.SL.208</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  <div @click.prevent="scrollToTop" class="scroll-to-top">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10">
      <g fill="#E5003F" fill-rule="evenodd">
        <path d="M15.94668896 9.94974752L7.4614076 1.46446615 8.87562114.0502526l8.48528137 8.48528136z"/>
        <path d="M10.29326376 1.4644658L1.80798238 9.94974718.39376882 8.53553362 8.8790502.05025224z"/>
      </g>
    </svg>
  </div>

  </footer>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import { scrollToTop } from 'sparnord-assets/mixins'

import 'vue-awesome/icons/phone'
import 'vue-awesome/icons/envelope'

export default {
  components: { Icon },
  mixins: [ scrollToTop ]
}
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/font-size';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

footer {
  position: relative;

  padding: 80px 0;

  color: $color-white;
  background-color: $color-black;

  // Dark line under footer
  &:after {
    position: absolute;
    bottom: 0;

    width: 100%;
    height: 25px;

    content: "";
    transform: translateY(100%);

    background-color: $color-black-x;
  }
}

// Footer logo
.logo {
  //max-width: 120px;
  flex: 0 0 120px;

  @media #{$below-breakpoint-768} {
    // max-width: 90px;
    flex: 0 0 33%;
  }

  @at-root .internet-explorer #{&} {
    max-width: 121px;
  }

  img {
    width: 100%;
    max-width: 120px;

    @media #{$below-breakpoint-768} {
      max-width: 90px;

      @at-root .internet-explorer #{&} {
        max-width: 121px;
      }
    }
  }
}

// Main footer
.main-footer {
  display: flex;
  align-items: flex-start;
  flex: 1 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  color: $color-white;
  @include font-size(13px, 14px);
  font-weight: 600;
  line-height: 1.67;

  @media #{$above-breakpoint-768} {
    padding-left: $global-padding * 10;
  }

  @media #{$below-breakpoint-768} {
    padding-left: $global-padding;
    flex: 1 1 calc((100% - 33%) - #{$global-padding});
  }

  p {
    @include font-size(13px, 14px);
  }
}

.main-footer-title {
  flex: 0 0 100%;

  margin-bottom: $global-padding;

  color: $color-white;

  @include font-size(15px, 17px);
  font-weight: 700;
}

// Sub footer
.main-sub-footer {
  display: flex;
  flex: 0 0 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.main-sub-footer__group {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  flex-wrap: wrap;

  div {
    display: flex;
    flex-direction: column;
  }
}

.main-sub-footer__group:first-child {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-right: auto;

  @media #{$above-breakpoint-768} {
    div + div {
      margin-left: 10%;
    }
  }

  @media #{$below-breakpoint-768} {
    flex-direction: column;

    div + div {
      margin-top: 15px;
      margin-left: 0;
    }
  }
}

.main-sub-footer__group:last-child {
  flex: 1 1 auto;
  margin-left: auto;
  margin-right: 0;

  div {
    display: inline-block;
  }

  span {
    display: inline-block;

    width: 75px;
    margin-right: 10px;
  }

  @media #{$below-breakpoint-768} {
    flex: 0 0 100%;

    margin-top: 50px;
  }
}

span {
  color: $color-grey-xx;
}

// Link
.link {
  transition: color $duration-normal $easeing-OutExpo;

  svg {
    transition: fill $duration-normal $easeing-OutExpo;
  }
}

.link:hover {
  color: $color-red-x;

  svg {
    fill: $color-red-x;
  }
}

// has icon
.has-icon {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;

  @at-root .internet-explorer #{&} {
    flex: 0 0 24px;
  }
}

.icon {
  margin-left: -$global-padding;
  padding-right: 10px;

  width: $global-padding;
  height: auto;

  @media #{$below-breakpoint-768} {
    display: none;
  }

  @at-root .internet-explorer #{&} {
    // display: none;
  }
}

.scroll-to-top {
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  bottom: 25px;
  left: $global-padding;

  height: 30px;
  width: 30px;

  border-radius: 50%;

  overflow: hidden;

  background-color: $color-black-x;

  cursor: pointer;

  svg {
    transform: scale(.7);
    transform-origin: center;
  }

  svg path {
    fill: $color-white;
  }

  @media #{$above-breakpoint-768} {
    display: none;
  }

  &:hover {
    svg {
      animation: arrow-up $duration-slow $easeing-InOutExpo forwards;
    }
  }
}

@keyframes arrow-up {
  0% {
    transform: translateY(0) scale(.7);
  }

  50% {
    transform: translateY(-40px) scale(.7);
  }

  50.1% {
    transform: translateY(40px) scale(.7);
  }

  100% {
    transform: translateY(0) scale(.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/partials/bottom.vue